import { convertUrl } from "../helpers/helper"
import { LowerResponse, Response } from "../types/backend.type"
import { CustomerReport, NttData } from "../types/diagnose.type"
import http from "../utils/http"
import api from "../utils/api"
import { ServiceDetailsTaas } from "../types/serviceDetails.type"
const checkOutage = async (
  token: string,
  body: any
): Promise<LowerResponse<any>> => {
  const response = await http.post(
    convertUrl(`checkOutage`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}
const updateCustomer = async (
  token: string,
  body: any
): Promise<Response<CustomerReport>> => {
  const response = await http.post(
    convertUrl(`updateCustomer`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}
const customerCheck = async (token: string, body: any) => {
  const response = await http.post(
    convertUrl(`customerCheck`),
    JSON.stringify(body),
    token,
    undefined
  )
  return response
}

// const customerCheckTaas = async (token: string, body: any) => {
//   const response = await http.post(
//     convertUrl(`customerCheck`),
//     JSON.stringify(body),
//     token,
//     undefined
//   )
//   return response
// }
const customerCheckTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<Response<ServiceDetailsTaas>> => {
  const response = await http.getTass(
    convertUrl('retrieveSR'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}
// Resolves a service id to the customer record(s) that hold its cases.
//
// RetrieveCustomerAccount returns only the most recently created customer
// record. Cases raised through NOCGRID, LIVE_CHAT and other channels sit under
// the others, so a lookup keyed on that one id cannot see them. See issue #54.
//
// Answers HTTP 201 on success, not 200.
const getSubscriberInfoByFuzzy = async (
  token: string,
  body: any,
  randomstring: string
): Promise<any> => {
  const response = await http.getTass(
    convertUrl('getSubscriberInfoByFuzzy'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}

const checkOutageTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<LowerResponse<NttData>> => {
  const response = await http.getTass(
    convertUrl('checkOutageTaas'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}

const updateCustomerTaas = async (
  token: string,
  body: any,
  randomstring: string
): Promise<Response<any>> => {
  const response = await http.postTass(
    convertUrl('updateCustomerTaas'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}
const iwsFilterDeviceList = async (token: string, body: any, randomstring: string) => {
  const response = await http.postIWSStatus(
    convertUrl('iwsFilterDeviceList'),
    JSON.stringify(body),
    token,
    randomstring
  )
  return response
}

export { checkOutage, updateCustomer, customerCheck, customerCheckTaas, checkOutageTaas, updateCustomerTaas, iwsFilterDeviceList, getSubscriberInfoByFuzzy }
